module.exports = __webpack_public_path__ + "img/checkout-lg.a37780d6.svg";